import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import SwiperCore from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import { Box, Container } from "@mui/material";
import useSystemHook from "./../../hooks/SystemHook";

SwiperCore.use([Autoplay, Navigation]);

const PromoBanner = () => {
  const { isMobile } = useSystemHook();

  const banner = (mobileNum, desktopNum) =>
    `https://argusweb.azureedge.net/argus-web/trade-show/banners/Banners-${
      isMobile ? mobileNum : desktopNum
    }.webp`;

  const banners = [
    {
      image: banner("04", "01"),
      link: "/products/all?vendor=beta_merchandising",
    },
    {
      image: banner("10", "09"),
      link: "/products/all?vendor=beta_merchandising",
    },
    {
      image: banner("12", "11"),
      link: "/products/all?vendor=beta_merchandising",
    },
  ];

  return (
    <Container maxWidth="lg" disableGutters sx={{ mt: 10 }}>
      <Swiper
        modules={[Autoplay, Navigation]}
        spaceBetween={50}
        slidesPerView={1}
        navigation
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: true,
        }}
      >
        {banners.map((bannerImage, index) => (
          <SwiperSlide key={index}>
            <Box
              sx={{
                position: "relative",
                width: "100%",
                overflow: "hidden",
              }}
            >
              <a href={bannerImage.link}>
                <img
                  src={bannerImage.image}
                  alt={`Promo Banner ${index + 1}`}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    objectPosition: "center",
                  }}
                />
              </a>
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>
    </Container>
  );
};

export default PromoBanner;
